import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  menuAberto = false;
  atendimentoAberto = false;

  toggleAtendimento(event: Event): void {
    event.preventDefault();
    this.atendimentoAberto = !this.atendimentoAberto;
  }

  fecharAtendimento(): void {
    this.atendimentoAberto = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-dropdown-wrap')) {
      this.atendimentoAberto = false;
    }
  }

  constructor() { }

  ngOnInit(): void { }

}
